<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-package-detail class="flex" [package]="package" (close)="close()"> </app-package-detail>
</div>
